import styled from 'styled-components';
import {qrShakeOnScan} from '../QrZoom/QrScanShake.css';

export const qrWrap = styled.div`
    position: relative;
    flex: 1 1 auto;
    min-height: 0;
    aspect-ratio: 1;
    width: auto;
    height: auto;
    max-width: 200px;
    max-height: 200px;
`;

export const qr = styled.button<{$isScanning?: boolean}>`
    width: 100%;
    height: 100%;
    overflow: clip;
    padding: 0;
    border: none;
    background: transparent;
    cursor: zoom-in;
    display: block;

    canvas {
        width: 100%;
        height: 100%;
        display: block;

        ${p => p.$isScanning && qrShakeOnScan}
    }
`;
